import Header from '../components/Header';
import './Home.css';
import { useNavigate } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../constants/contact';
import { HEADACHE_NOTE_APP_STORE_URL, HEADACHE_NOTE_GOOGLE_PLAY_URL } from '../constants/storeLinks';
import headacheNoteIcon from '../assets/headache-note-icon.png';

function Home() {
  const navigate = useNavigate();

  const handleSmoothScroll = (event, targetElementId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetElementId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHeadacheNoteClick = () => {
    navigate('/headache-note');
  };

  return (
    <div className="Home" id="top">
      <Header />
      <main>
        <section className="Hero">
          <h1 className="Hero-title">あなたの人生がより良くなるアプリを</h1>
          <p className="Hero-subtitle">シンプルで実用的なアプリを提供しています。</p>
        </section>

        <section id="apps" className="Apps">
          <h2>公開中のアプリ</h2>
          <div className="AppGrid">
            {/* 頭痛ノート */}
            <article className="AppCard" role="button" tabIndex={0} onClick={handleHeadacheNoteClick} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleHeadacheNoteClick(); } }}>
              <div className="AppCard-body">
                <h3 className="AppCard-title"><img className="AppCard-icon" src={headacheNoteIcon} alt="" aria-hidden="true" />頭痛ノート</h3>
                <p className="AppCard-desc">頭痛を記録・集計する「頭痛ノート」<br />頭痛で悩むあなたのための、シンプルで使いやすい記録アプリ。</p>
                <div className="StoreLinks">
                  <a
                    className="StoreLink"
                    href={HEADACHE_NOTE_APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="App Store"
                  >
                    App Store
                  </a>
                  <a
                    className="StoreLink"
                    href={HEADACHE_NOTE_GOOGLE_PLAY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Google Play"
                  >
                    Google Play
                  </a>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section id="about" className="About">
          <h2>開発者について</h2>
          <p>
            個人でデザインから実装、運用まで一貫して行っています。
            日常の課題を解決する使いやすいアプリを開発しています。
          </p>
        </section>


        <section id="contact" className="Contact">
          <h2>お問い合わせ</h2>
          <p>ご連絡はメールで承ります。</p>
          <p><a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></p>
        </section>


      </main>

      <footer className="SiteFooter">
        <small>© {new Date().getFullYear()} YStudioX</small>
      </footer>
    </div>
  );
}

export default Home;
